import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { PropTypes } from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import {
  StoreUtil,
} from 'doctivity-shared/utils';
import {
  withRouter,
} from 'utils';
import {
  DynamicTable,
  LoadingView,
  OverlineLabel,
  UnderlineData,
  SmallIconTextButton,
} from 'components';

import {
  Typography,
  Card,
  CardContent,
  Grid,
} from '@mui/material';

import {
  loadTagNamespace,
  upsertTagNamespace,
} from 'store/actions/tagNamespacesActions';
import {
  queryTags,
  upsertTag,
} from 'store/actions/tagsActions';

import { TagNamespaceEditDialog } from './TagNamespaceEditDialog';
import { TagEditDialog } from './TagEditDialog';

const styles = (theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerSpacer: {
    marginRight: theme.spacing(2),
    flex: 1,
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  detailCard: {
    marginBottom: theme.spacing(3),
  }
});

// this controls which columns are displayed and how they are looked up in data
const columns = [
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Created By',
    key: 'user',
    format: (u) => (u ? `${u.last_name}, ${u.first_name}` : ''),
  },
];

class TagsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: {
        where: {
          namespace_id: 0, // will be set in fetchTags
        },
        order: [
          ['name', 'ASC'],
        ],
        include: [
          {
            attributes: ['id', 'first_name', 'last_name'],
            association: 'user',
          },
        ],
        limit: 50,
        offset: 0,
      },
      addDialogOpen: false,
      editDialogOpen: false,
      tagData: null,
    };
  }

  componentDidMount() {
    this.fetchNamespace();
    this.fetchTags();
  }

  componentDidUpdate(prevProps) {
    if (this.props.params.tagNamespaceId !== prevProps.params.tagNamespaceId) {
      this.fetchNamespace();
      this.fetchTags();

    // is object getting edited?
  } else if (this.props.editingTag !== prevProps.editingTag) {
      // if so and it is newr than the list, update list
      if (StoreUtil.hasSavedSinceLoad(this.props.editingTag, this.props.tags)) {
        this.fetchTags();
      }
    }
  }
  fetchNamespace() {
    this.props.dispatch(loadTagNamespace(this.props.params.tagNamespaceId));
  }

  fetchTags() {
    const {
      query,
    } = this.state;

    query.where.namespace_id = this.props.params.tagNamespaceId;
    this.props.dispatch(queryTags(query));
  }

  render() {
    const {
      user,
      tagNamespace,
      tags,
      classes,
    } = this.props;

    const {
      query,
    } = this.state;

    // is a user being edited now?
    console.log('is loaded: ', StoreUtil.isLoaded(tagNamespace));

    if (StoreUtil.isSaving(this.props.editingTag)
      || StoreUtil.isSaving(this.props.editingTagNamespace)
      || !StoreUtil.isLoaded(tagNamespace)
      || tagNamespace.data.id !== parseInt(this.props.params.tagNamespaceId, 10)) {
      return (<LoadingView />);
    }

    return (
      <>
        <Helmet defer={false}>
          <title>Labels</title>
        </Helmet>
        <div className={classes.container}>
          <div className={classes.detailCard}>
            <SmallIconTextButton
              onClick={this.onBack}
              icon='chevron_left'
              text='Label Types'
            />
          </div>
          <Card className={classes.detailCard}>
            <CardContent>
              <div className={classes.headerContainer}>
                <Typography
                  component='h2'
                  variant='h6'
                  color='primary'
                  gutterBottom
                >
                  Label Type
                </Typography>
                <div className={classes.headerSpacer} />
                <SmallIconTextButton
                  onClick={this.onOpenEditDialog}
                  icon='edit'
                  text='Edit Label Type'
                />
              </div>
              <Grid container>
                <Grid item xs={6}>
                  <OverlineLabel>Name</OverlineLabel>
                  <UnderlineData>{tagNamespace.data.name}</UnderlineData>
                  <OverlineLabel>Is Required for Activity Notes</OverlineLabel>
                  <UnderlineData>
                    {tagNamespace.data.activity_notes_required ? 'Yes' : 'No'}
                  </UnderlineData>
                  <OverlineLabel>Allow Multiple for Activity Notes</OverlineLabel>
                  <UnderlineData>
                    {tagNamespace.data.activity_notes_multiple ? 'Yes' : 'No'}
                  </UnderlineData>
                   <OverlineLabel>Allow for Activity Notes</OverlineLabel>
                  <UnderlineData>
                    {tagNamespace.data.activity_notes_drop_down ? 'Yes' : 'No'}
                  </UnderlineData>
                  <OverlineLabel>Allow for Providers</OverlineLabel>
                  <UnderlineData>
                    {tagNamespace.data.providers_drop_down ? 'Yes' : 'No'}
                  </UnderlineData>
                  <OverlineLabel>Allow Multiple for Providers</OverlineLabel>
                  <UnderlineData>
                    {tagNamespace.data.providers_multiple ? 'Yes' : 'No'}
                  </UnderlineData>
                   <OverlineLabel>Allow for Organizations</OverlineLabel>
                  <UnderlineData>
                    {tagNamespace.data.organizations_drop_down ? 'Yes' : 'No'}
                  </UnderlineData>
                  <OverlineLabel>Allow Multiple for Organizations</OverlineLabel>
                  <UnderlineData>
                    {tagNamespace.data.organizations_multiple ? 'Yes' : 'No'}
                  </UnderlineData>
 
                </Grid>
                <Grid item xs={6}>
                  <OverlineLabel>Client</OverlineLabel>
                  <UnderlineData>{tagNamespace.data.client.name}</UnderlineData>
                  <OverlineLabel>Created By</OverlineLabel>
                  <UnderlineData>
                    {`${tagNamespace.data.user.last_name}, ${tagNamespace.data.user.first_name}`}
                  </UnderlineData>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <DynamicTable
            header={
              <div className={classes.headerContainer}>
                <Typography
                  component='h2'
                  variant='h6'
                  color='primary'
                  gutterBottom
                >
                  Labels in Group
                </Typography>
                <div className={classes.headerSpacer} />
                {user.is_admin && (
                  <SmallIconTextButton
                    onClick={this.onOpenAddDialog}
                    icon='add'
                    text='Add Label'
                  />
                )}
              </div>
            }
            columns={columns}
            showFilters={false}
            query={query}
            data={tags}
            onQueryChange={this.onQueryChange}
            onRowClick={this.onRowClick}
          />
          <TagNamespaceEditDialog
            open={this.state.editDialogOpen}
            onSave={this.onSaveTagNamespace}
            onClose={this.onCloseEditDialog}
            tagNamespaceData={tagNamespace.data}
          />
          <TagEditDialog
            open={this.state.addDialogOpen}
            onSave={this.onSaveTag}
            onClose={this.onCloseAddDialog}
            tagData={this.state.tagData}
            validate={this.customTagValidate}
          />
        </div>
      </>
    );
  }
   
  customTagValidate = (formData, errors) => {
      const isOk = this.props.tags?.data?.rows?.every((row) => row.name !== formData.name);
      if (!isOk) {
        errors.name.addError('Duplicate label: '+formData.name);
      }
      return errors; 
    }


  onQueryChange = (query) => {
    this.setState({ query }, this.fetchData);
  };

  onOpenEditDialog = () => {
    this.setState({
      editDialogOpen: true,
    });
  };

  onCloseEditDialog = () => {
    this.setState({
      editDialogOpen: false,
      tagData: null,
    });
  };

  onSaveTagNamespace = (tagNamespace) => {
    tagNamespace.user_id = this.props.user.id;
    this.props.dispatch(upsertTagNamespace(tagNamespace));
    this.onCloseEditDialog();
  };

  onOpenAddDialog = () => {
    this.setState({
      addDialogOpen: true,
    });
  };

  onCloseAddDialog = () => {
    this.setState({
      addDialogOpen: false,
      tagData: null,
    });
  };

  onSaveTag = (tag) => {
    tag.user_id = this.props.user.id;
    tag.client_id = this.props.tagNamespace.data.client_id;
    tag.namespace_id = this.props.tagNamespace.data.id;
    this.props.dispatch(upsertTag(tag));
    this.onCloseAddDialog();
  };

  onRowClick = (tag) => {
    this.setState({
      addDialogOpen: true,
      tagData: tag,
    });
  }

  onBack = () => {
    this.props.router.navigate('/admin/labels');
  };
}

TagsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  user: PropTypes.object,
  params: PropTypes.object.isRequired,
  tagNamespace: PropTypes.object.isRequired,
  tags: PropTypes.object.isRequired,
  editingTag: PropTypes.object,
  editingTagNamespace: PropTypes.object,
};

function mapStateToProps(state, props) {
  return {
    user: state.user,
    tagNamespace: StoreUtil.get(
      state.tagNamespaces,
      StoreUtil.COMMON_ITEM,
      props.params.tagNamespaceId,
    ),
    tags: StoreUtil.get(state.tags, StoreUtil.COMMON_TABLE),
    editingTag: StoreUtil.get(state.tags, StoreUtil.COMMON_EDIT_ITEM),
    editingTagNamespace: StoreUtil.get(state.tagNamespaces, StoreUtil.COMMON_EDIT_ITEM),
  };
}

const styled = withStyles(styles)(TagsPage);
const connected = connect(mapStateToProps)(styled);
const routed = withRouter(connected);
export { routed as TagsPage };
